import { FunctionComponent, PropsWithChildren } from "react";
import * as Styled from "./styles";

interface MainAppContainerProps extends PropsWithChildren {
  name?: string;
  isLoading: boolean;
  showModal: boolean;
  closeModal: (...args: any) => void;
}

const MainAppContainer: FunctionComponent<MainAppContainerProps> = ({
  children,
  name = "container",
  isLoading,
  showModal,
  closeModal,
}: MainAppContainerProps) => {
  return (
    <Styled.Overlay data-name={name} $isLoading={isLoading}>
      <Styled.Main id="main">
        <Styled.MainContainerDiv>
          {showModal && <Styled.MainContainerModalOverlay onClick={closeModal} />}
          {children}
        </Styled.MainContainerDiv>
      </Styled.Main>
    </Styled.Overlay>
  );
};

export default MainAppContainer;
